import Logo from '../../../public/svg_images/logo.svg';

function LogoSvg() {
  return (
    <div style={{marginLeft:"4px",display:"flex",alignItems:"center",display:"block"}}>
    <Logo
      width={52}
      height={35}
      aria-hidden="true" 
    />
    </div>
  );
}

export default LogoSvg;